import request from "@/utils/request"
import service from "@/utils/service"

// 根据用户pk查询设定的自由模式列表
export function findProfileListByUserPk(pk_user, deviceType) {
  return request({
    url: service.tcode + "/tcode/api/pub/findProfileListByUserPk/" + pk_user + "/" +deviceType,
    method: "post"
  });
}

//根据pk查询设定的自由模式参数信息
export function findProfileInfoByPk(pk) {
  return request({
    url: service.tcode + "/tcode/api/pub/getUserProfileInfoByPk/" + pk,
    method: "get"
  });
}

/**
 * 更新用户模式参数接口
 * @param data 保存数据
 */
export function saveUserProfileInfo(data) {
  return request({
    url: service.tcode + "/tcode/api/pub/saveUserProfileInfo",
    method: "post",
    data: data
  })
}

/**
 * 更新用户模式参数接口
 * @param data 保存数据
 */
export function updateAllProfileAxisRangeOfUser(data) {
  return request({
    url: service.tcode + "/tcode/api/pub/updateAllProfileAxisRangeOfUser",
    method: "post",
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/platform/motions.js